import {
    GeneralAppSettingsAction,
    GeneralAppSettingsType,
} from '../../actionTypes/settings/generalAppSettings';
import { GeneralAppSettingsRequest } from '../../types';
import { SuSyApi } from '../../../api/susyApi';
import { Dispatch } from 'react';
import { RootState } from '../..';

export const updateGeneralAppSettings =
    (generalAppSettings: GeneralAppSettingsRequest, logo: File | null) =>
    async (
        dispatch: Dispatch<GeneralAppSettingsAction>,
        getState: () => RootState
    ) => {
        const formData = new FormData();

        if (logo) {
            formData.append(`generalAppSettings_logo`, logo);
        }

        formData.append(
            'generalAppSettings_OtherSettings',
            JSON.stringify(generalAppSettings)
        );
        const response = await SuSyApi.put(
            '/settings/generalAppSettings',
            formData
        );

        const localization = getState().localization;

        dispatch({
            type: GeneralAppSettingsType.UPDATE_GENERAL_APP_SETTINGS,
            payload: response.data,
            localization,
        });
    };

export const getGeneralAppSettings =
    () =>
    async (
        dispatch: Dispatch<GeneralAppSettingsAction>,
        getState: () => RootState
    ) => {
        const response = await SuSyApi.get('/settings/generalAppSettings');

        const localization = getState().localization;
        dispatch({
            type: GeneralAppSettingsType.GET_GENERAL_APP_SETTINGS,
            payload: response.data,
            localization,
        });
    };
